export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen3_in.ecd0f28a.mp4";